// src/components/LegalFooter.jsx
// Small links at the bottom of every page: help, privacy policy, terms, and the analytics choice.
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { reviewConsent } from '../analytics';

function LegalFooter() {
    const { pathname } = useLocation();
    if (pathname.endsWith('/screen')) return null; // the big-screen view is only the tournament
    return (
        <footer className="legal-footer">
            <Link to="/help">Help</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <button className="link-button" onClick={() => reviewConsent()}>
                Privacy settings
            </button>
        </footer>
    );
}

export default LegalFooter;
